import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from '../../../common/component/modal/FJCommonModal';
import FJRecordingTiming from "../view/recordingScreen/FJRecordingTiming";
import {FJRecordingAction} from '../../../redux/action/FJRoot.action'

class FJRecordingTimingModalContainer extends Component {

  render() {
    let {
      visible,
      endRecording
    } = this.props;
    return (
      <FJCommonModal visible={visible}
                     width='380px'
      >
        <FJRecordingTiming visible={visible} endRecording={endRecording} />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowScreenRecordingTimingModal,
  }
};

const mapDispatchToProps = function () {
  return {
    endRecording: function () {
      FJRecordingAction.endRecordingScreenAction();
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJRecordingTimingModalContainer);
